import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'programPadding'
})
export class ProgramPaddingPipe implements PipeTransform {

  /**
   * 
   * @param width in vw
   * @returns 
   */
  transform(width: number): unknown {
    if (Math.trunc(width/2) > 3) {
      return '2vw';
    } else {
      const customPadding = Math.abs(width / 4);
      return `2vw ${customPadding}vw`;
    }
  }

}
